import { ShoppingBag, Tag, Link2, Settings } from 'lucide-react'

export function WelcomeView({ onSelectChannel, onOpenSettings }) {
  return (
    <div className="px-[18px]">
      {/* Header (wie Dashboard) */}
      <div className="flex items-center justify-between py-2">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md overflow-hidden">
            <img src="/boothly-logo.png" alt="Boothly" className="w-full h-full object-cover" />
          </div>
          <span className="font-medium text-base">Boothly</span>
        </div>
        <button onClick={onOpenSettings} aria-label="Einstellungen" className="text-muted-foreground">
          <Settings size={20} />
        </button>
      </div>

      {/* Begrüßung */}
      <div className="mt-3 mb-5">
        <h3 className="text-[22px] font-medium">Willkommen bei Boothly</h3>
        <p className="text-[13px] text-muted-foreground mt-1">Wähle, womit du startest.</p>
      </div>

      {/* Kanal-Auswahl — Tint-Karten (wie CreateBereichSheet) */}
      <button
        onClick={() => onSelectChannel?.('online')}
        className="w-full text-left rounded-2xl p-4 flex items-center gap-4 border active:scale-[0.98] transition-transform mb-3"
        style={{ background: 'var(--tint-online)', borderColor: 'var(--border-default)' }}
      >
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'var(--accent-online)' }}>
          <ShoppingBag size={22} className="text-white" />
        </div>
        <div className="min-w-0">
          <div className="text-[17px] font-semibold">Online-Store</div>
          <div className="text-[13px] text-[var(--label-secondary)] mt-0.5">Für eBay, Etsy, Shopify & Co.</div>
        </div>
      </button>

      <button
        onClick={() => onSelectChannel?.('flea')}
        className="w-full text-left rounded-2xl p-4 flex items-center gap-4 border active:scale-[0.98] transition-transform"
        style={{ background: 'var(--tint-troedel)', borderColor: 'var(--border-default)' }}
      >
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'var(--accent-troedel)' }}>
          <Tag size={22} className="text-white" />
        </div>
        <div className="min-w-0">
          <div className="text-[17px] font-semibold">Trödel</div>
          <div className="text-[13px] text-[var(--label-secondary)] mt-0.5">Flohmarkt-Verkäufe, Markttage, Spontan-Verkauf.</div>
        </div>
      </button>

      {/* Dritter Weg — neutral, kein Channel-Akzent (Beitreten ist kein Kanal) */}
      <button
        onClick={() => onSelectChannel?.('join')}
        className="w-full text-left rounded-2xl p-4 flex items-center gap-4 border active:scale-[0.98] transition-transform mt-3"
        style={{ background: 'var(--fill-quaternary)', borderColor: 'var(--border-default)' }}
      >
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'var(--fill-tertiary)' }}>
          <Link2 size={22} style={{ color: 'var(--label-secondary)' }} />
        </div>
        <div className="min-w-0">
          <div className="text-[17px] font-semibold">Mit Code beitreten</div>
          <div className="text-[13px] text-[var(--label-secondary)] mt-0.5">Tritt einem fremden Bereich als Helfer bei.</div>
        </div>
      </button>
    </div>
  )
}
